import { useCallback, useEffect, useState } from "react";
import { subscribeToAuth } from "./authService";
import { isFirebaseConfigured } from "./firebaseApp";
import { ensureUserProfile } from "./profileService";

export const useAuthState = () => {
	const [user, setUser] = useState(null);
	const [profile, setProfile] = useState(null);
	const [loading, setLoading] = useState(isFirebaseConfigured);
	const [profileLoading, setProfileLoading] = useState(false);

	useEffect(() => {
		const unsubscribe = subscribeToAuth((nextUser) => {
			setUser(nextUser);
			setLoading(false);
		});

		return unsubscribe;
	}, []);

	useEffect(() => {
		let cancelled = false;

		if (!user) {
			setProfile(null);
			setProfileLoading(false);
			return undefined;
		}

		setProfileLoading(true);
		ensureUserProfile(user)
			.then((nextProfile) => {
				if (!cancelled) setProfile(nextProfile);
			})
			.catch((error) => {
				console.error("Profile bootstrap failed.", error);
				if (!cancelled) setProfile(null);
			})
			.finally(() => {
				if (!cancelled) setProfileLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [user]);

	const refreshProfile = useCallback(async () => {
		if (!user) return null;
		const refreshed = await ensureUserProfile(user);
		setProfile(refreshed);
		return refreshed;
	}, [user]);

	return {
		user,
		profile,
		loading,
		profileLoading,
		configured: isFirebaseConfigured,
		refreshProfile,
	};
};
